// extracted by mini-css-extract-plugin
module.exports = {"noDocs":"FileManager_noDocs__3gHLr"};